import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { SimpleChipItem } from "@similarweb/ui-components";

export const Chip = styled(SimpleChipItem).attrs<{ $isActive?: boolean }>((props) => ({
    $isActive: props.$isActive ?? false,
}))<{ $isActive?: boolean }>`
    ${({ $isActive }) =>
        $isActive === false &&
        `
        .SWReactIcons {
            height: 10px;
            width: 10px;
        }
    `}
    ${({ $isActive }) =>
        $isActive &&
        `
        background-color: ${colorsPalettes.carbon[400]};

        .ChipItemText {
            color: ${colorsPalettes.carbon[0]};
            
        }
        svg path {
            fill: ${colorsPalettes.carbon[0]} !important;
        }

        &:hover {
            background-color: ${colorsPalettes.carbon[500]};
            cursor: pointer;
            ${setFontVariant("tooltip", colorsPalettes.carbon[400])};
        }
    `}
`;
